module.exports = __webpack_public_path__ + "img/pdf.32e52c3c.jpg";